export default __webpack_public_path__ + "370737ff1816ebcaf9112d92096d64d0.png";